
  <form [formGroup]="form" class="form">
    <kendo-gridlayout [rows]="[{height:40},{height:40}]" [cols]="[{width:90},{width:250}]" [gap]="{rows:1, cols:40}">

      <kendo-gridlayout-item [row]="1" [col]="1" [colSpan]="1">
        <kendo-label>Unique Identifier</kendo-label>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [row]="1" [col]="2" [colSpan]="1">
        <app-select-field [control]="availableItems"></app-select-field>
      </kendo-gridlayout-item>

    </kendo-gridlayout>
  </form>

  <button kendoButton class="btnSave" (click)="save()">Re-assign</button>
